/* eslint-disable @typescript-eslint/indent */

// Core
import styled, { css } from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { StatusIndicatorProps } from '../../../../../../layout/elements/StatusIndicator';

/** Reusable styles */
const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.lubricationUnitDrawer.borderColor;

const flexCenterBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OverallStatusContainer = styled.div`
  ${flexCenterBetween};
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const CoolerFanStatusContainer = styled.div`
  ${flexCenterBetween};
  padding: 19px 24px;
`;

export const PermissiveItem = styled.li<Pick<StatusIndicatorProps, 'status'>>`
  padding: 12px;
  background-color: ${({ status, theme }) => (status !== 'alarm'
    ? 'transparent'
    : theme.color.crusherDashboard.lubricationUnitDrawer.descriptionListErrorBackgroundColor
  )};
  border-radius: 4px;

  margin: 0 1rem 0 0.75rem;
  
  &:first-of-type {
    margin-top: 1rem;
  };
`;

export const LubricationContainer = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
`;

export const RunningStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  row-gap: 24px;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    border-right: 1px solid ${borderColor};
  };
`;

export const LubePressureContainer = styled.div`
  ${flexCenterBetween};
  height: 100%;
  justify-content: center;
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    width: calc(100% + 2px);
  };
`;

export const WinterModeStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 16px;
  };
`;

export const WinterModeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const ThermometerContainer = styled(Col)<{ divider?: boolean }>`
  border-right: ${({ divider, theme }) => (
    divider
      ? `1px solid ${borderColor({ theme })}`
      : 'none'
  )};
  border-bottom: 1px solid ${borderColor};
  padding: 0.75rem 0;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 0;
  };
`;

export const PermissiveListContainer = styled.ul<{
  borderBottom?: boolean,
  borderRight?: boolean,
}>`
  list-style: none;
  margin: 0;
  height: 100%;
  padding: 0.75rem 1rem;

  ${({ borderBottom }) => borderBottom && css`
    border-bottom: 1px solid ${borderColor};
  `};
  
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    :first-of-type {
      ${({ borderRight }) => borderRight && css`
        border-right: 1px solid ${borderColor};
      `};
    };
  };
`;
